export default __webpack_public_path__ + "BG-4bcbe707fad7e73854f0373ef4e8294e.jpeg";